export const capitalize = (value) => {
  const valueString = !value && value !== 0 ? '' : value.toString();
  return `${valueString.charAt(0).toUpperCase()}${valueString.slice(1)}`;
};

export const currency = value => (
  Number(value).toLocaleString()
);



// WEBPACK FOOTER //
// ./src/utils/filters.js